module.exports = __webpack_public_path__ + "static/media/logo.0d7d5594.png";